import axios from '../utils/axios/index.js'

//获取验证码图片
export const captcha = (params) => {
    return axios.post('api/auth/captcha',params)
}
//登录
export const axiosLogin = (data) => {
    return axios.post('api/auth/login',data)
}
//注册
export const axiosRegist = (data) => {
    return axios.post('api/auth/register',data)
}
//获取信息
export const me = () => {
    return axios.post('/api/auth/me')
}
// 获取语言
export const lang = (params) => {
    axios.defaults.params = {}
    axios.defaults.data = {}
    return axios.get('/api/language/getList',{params})
}
//获取活动
export const axiosActivt = () => {
    return axios.get('/api/activities')
}
//获取活动
export const axiosActivtView = (number) => {
    axios.defaults.params = {}
    axios.defaults.data = {}
    let lang = JSON.parse(localStorage.getItem('language')).value
    return axios.get(`/api/activity/${number}&lang=${lang}`)
}
//获取直播类型/游戏类型
export const axiosGetGameType = (params)=>{
    return axios.get('api/games/apisv2',{params})
}
//获取直播/游戏下的具体信息
export const axiosGetGameInfo = (params) => {
    return axios.get('api/games/listsv2',{params})
}
//获取直播地址
export const axiosVideoUrl = (data) => {
    return axios.post('/api/bridge/loginBridge',data)
}
//获取公告
export const axiosGetGG = () => {
    return axios.get('/api/system/notices')
}
// 获取首页轮播图
export const axiosGetImg = (params)=>{
    return axios.get('/api/banners',{params})
}
// 获取支付方式
export const payments = (params) => {
    return axios.get("/api/payments/list",{params})
}
// 更具支付方式获取支付
export const axiosOnline = (params) => {
    return axios.get("/api/payment/online/list",{params})
}
// 支付跳转
export const recharge = (params) => {
    return axios.post("/api/recharge/online",params)
}
// 修改密码
export const modifyPassword = (params)=>{
    return axios.post("/api/member/password/modify",params)
}
// 修改支付密码
export const ChangePaymentPassword = (params)=>{
    return axios.post("/api/member/drawing_pwd/modify",params)
}
// 提现接口
export const Withdrawal = (params)=>{
  return axios.post("/api/drawing",params)
}
// 显示银行卡
export const queryBankCard = () =>{
  return axios.get(`/api/member/bank`)
}
// 添加银行卡
export const addbankcard = (params) => {
  return axios.post('/api/member/bank',params)
}
// 游戏记录
export const gamerecord = (params)=>{
  return axios.post('/api/game/record?lang=zh_cn',params)
}
// 交易记录
export const transactionRecord = (params)=>{
  return axios.post('/api/recharge/list?lang=zh_cn',params)
}



// 获取游戏列表
export const gameList = ()=>{
  return axios.get('/day7/getGameCodeList')
}
// 开始游戏
export const StartGame = (params)=>{
  return axios.post('api/day7/day7LoginV2',params)
}
// 获取游戏里的余额
export const GameBalance = (params)=>{
  return axios.get(`/api/day7/getAllBalance?currency=THB&platType=${params.platType}`)
}
// 体现接口
// export const Withdraw = async (params) => {
//   return axios.post('/api/drawing',params)
// }

export const Withdraw = async (params) => {
  try {
    const res = await axios.post('/api/drawing', params);
    alert("The withdrawal application has been submitted successfully.Please wait for the administrators review.");
    return res; // Assuming you want to return the data from the response
  } catch (error) {
    alert(error.response.data.message);
    return error
  }
}



// WEBPACK FOOTER //
// ./src/api/apiIndex.js